<!--
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-23 09:39:47
-->


<template>
  <section>
    <div class="role">
      <div class="roleLeft" style="min-width:150px">
        <div :class="['roleLeft_List', 'clickTree' ]">
          <!--          <el-button-->
          <!--              type="primary"-->
          <!--              icon="el-icon-orange"-->
          <!--              @click="getstaffList()"-->
          <!--          >全部-->
          <!--          </el-button>-->
          <el-tree
              :data="treeList"
              node-key="orgId"
              default-expand-all
              :expand-on-click-node="false"
              ref="adminTree"
              :props="defaultProps_one"
              @check="getstaffList"
              @node-click="getstaffList">
          </el-tree>
        </div>
      </div>
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchAdminLsit"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" :value="1" key="1"></el-option>
            <el-option label="禁用" :value="0" key="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchAdminLsit"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              border
              style="width: 100%"
              row-key="number"
              v-loading="loading"
          >
            <el-table-column
                fixed
                label="序号"
                prop="staffId"
                type="index"
                width="100"
            >
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="工号"></el-table-column>
            <el-table-column prop="account" label="账号" min-width="120">
            </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="120">
            </el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="130">
            </el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="130">
            </el-table-column>
            <el-table-column prop="sex" label="性别">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.sex == 0
                        ? "保密"
                        : scope.row.sex == 1
                        ? "男"
                        : "女"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="orgs" label="组织" min-width="120">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.org ? scope.row.org.name : '' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="posts" label="岗位" min-width="120">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.post ? scope.row.post.name : '' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :disabled="scope.row.sysdba==1 && statusShow"
                    :inactive-value="0"
                    @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column v-if="deleteShow || editShow || launchShow || roleShow || resetShow" fixed="right"
                             label="操作" align="left" min-width="300">
              <template slot-scope="scope">
                <div>
                  <el-button
                      v-if="editShow"
                      @click="handleClick('change', scope.row)"
                      plain
                      size="small"
                  >修改
                  </el-button
                  >
                  <el-button
                      v-if="launchShow"
                      type="danger"
                      size="small"
                      plain
                      @click="getChannelList(scope.row)"
                  >投放
                  </el-button
                  >
                  <el-button
                      v-if="roleShow"
                      type="success"
                      size="small"
                      plain
                      @click="handleClick('menu', scope.row)"
                  >角色
                  </el-button
                  >
                  <el-button
                      v-if="resetShow"
                      type="danger"
                      size="small"
                      plain
                      @click="reset(scope.row)"
                  >重置
                  </el-button
                  >
                  <el-button
                      v-if="deleteShow"
                      type="primary"
                      plain
                      size="small"
                      @click="del(scope.row)"
                  >删除
                  </el-button
                  >
                </div>
                <!-- <div v-else>无操作项</div> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
            <!-- :page-sizes="[10, 15, 20,25 ]" -->
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        :title="
        clickType == 'addNext'
          ? '新增管理员信息'
          : clickType == 'edit'
          ? '编辑管理员组'
          : clickType == 'change'
          ? '修改管理员信息'
          : ' 角色分配'
      "
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="760px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <!-- 角色 菜单分配 -->
          <el-form-item v-if="clickType == 'menu'" class="item" label="名称"
          >{{ params.name }}
          </el-form-item>
          <el-form-item v-if="clickType == 'menu'" class="item" label="账号"
          >{{ params.account }} ( {{ params.number }} )
          </el-form-item>
          <el-form-item
              v-if="clickType == 'menu'"
              class="item"
              label="角色渠道"
          >
            <div class="dialog-tree">
              <el-tree
                  :data="permissionData"
                  show-checkbox
                  node-key="roleId"
                  ref="treeList"
                  default-expand-all
                  :expand-on-click-node="false"
                  :props="defaultProps"
              >
              </el-tree>
            </div>
          </el-form-item>

          <el-form-item label="头像" v-if="clickType == 'addNext' || clickType == 'change'">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicy"
                    v-if="isMoer && !params.head"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="file"
                  @change="getFile"
                  accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>
          <!-- 新增  修改 -->
          <div style="display: flex;align-items: center">
            <el-form-item
                v-if="clickType == 'addNext' || clickType == 'change'"
                label="账号"
                prop="account"
            >
              <el-input
                  :disabled="clickType == 'change' ? true : false"
                  clearable
                  style="width: 220px"
                  placeholder="账号一旦添加不可修改,最多10个字符"
                  v-model="params.account"
              ></el-input>
            </el-form-item>
            <el-form-item
                class="item"
                v-if="clickType == 'change'"
                label="工号"
            >
            <span
            >{{ clickType == "change" ? params.number : "由系统生成" }}
            </span>
            </el-form-item>
          </div>
          <el-row v-if="clickType == 'addNext' || clickType == 'change'">
            <el-col :span="10">
              <el-form-item required label="姓名" prop="name">
                <el-input
                    type="text"
                    v-model="params.name"
                    clearable
                    placeholder="姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item required label="手机号" prop="phone">
                <el-input
                    clearable
                    v-model="params.phone"
                    placeholder="11位手机号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="clickType == 'addNext' || clickType == 'change'">
            <el-col :span="10">
              <el-form-item
                  v-if="clickType == 'addNext' || clickType == 'change'"
                  class="item"
                  label="性别"
                  prop="sex"
              >
                <el-radio v-model="params.sex" :label="1">男</el-radio>
                <el-radio v-model="params.sex" :label="2">女</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item label="邮箱" prop="email">
                <el-input
                    clearable
                    v-model="params.email"
                    placeholder="邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="clickType == 'addNext' || clickType == 'change'">
            <el-col :span="10" style="position: relative">
              <span class="clear_icon_items">*</span>
              <el-form-item label="组织" prop="dictDataSelect">
                <el-select
                    v-model="dictDataSelect"
                    placeholder="请选择"
                    clearable
                    filterable
                    ref="selectReport"
                >
                  <el-option style="height: auto" :value="dictDataSelect">
                    <el-tree
                        :data="orgData"
                        :props="orgsProps"
                        ref="orgsTree"
                        default-expand-all
                        :render-after-expand="true"
                        :expand-on-click-node="false"
                        @node-click="handleNodeClick"
                    ></el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="13" style="position: relative">
              <span class="clear_icon_items">*</span>
              <el-form-item label="岗位" prop="positionDataSelect">
                <el-select
                    v-model="positionDataSelect"
                    placeholder="请选择"
                    clearable
                    filterable
                    ref="selectReportPosi"
                >
                  <el-option required style="height: auto" :value="positionDataSelect">
                    <el-tree
                        :data="posData"
                        :props="positionProps"
                        ref="positionTree"
                        default-expand-all
                        :render-after-expand="true"
                        :expand-on-click-node="false"
                        @node-click="handleNodeClickPosi"
                    ></el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>

    <!-- 渠道配置 -->
    <el-dialog
        title="投放账号管理"
        :visible.sync="channelDialogVisible"
        :close-on-click-modal="false"
        width="1070px"
        class="public-dialog"
    >
      <div style="cursor: pointer" class="public-dialog-form" v-loading="loading">
        <div style="display: flex">
          <div class="channel_items" style="align-items: center">
            <div class="titles">名称：</div>
            <div>{{ UserInformation.name }}</div>
          </div>
          <div class="channel_items" style="align-items: center">
            <div class="titles">账号：</div>
            <div> {{ UserInformation.account }}（{{ UserInformation.number }}）</div>
          </div>
        </div>
        <div class="channel_items" style="align-items: center">
          <div class="titles">部门/岗位：</div>
          <div>{{ UserInformation.org ? UserInformation.org.name : '' }} /
            {{ UserInformation.post ? UserInformation.post.name : '' }}
          </div>
          <el-button type="primary" @click="changBindShow" style="margin-left: 20px">绑定</el-button>
        </div>
        <div class="channel_items">
          <div class="titles">渠道账户：</div>
          <div class="table_cou">
            <div class="tab_header_th">
              <div class="names">渠道</div>
              <div class="inde_auto">序号</div>
              <div class="name_box_auto">名称</div>
              <div class="comtemts">账号</div>
              <div class="code_box">标识</div>
              <div class="post_inof">投放方式</div>
              <div class="code_box">说明</div>
              <div class="qutuns">状态</div>
              <div class="qutuns">操作</div>
            </div>
            <div class="tab_body_content">
              <div class="tab_content_td" v-if="item.staffChannels.length" v-for="(item,index) in accountnNumberList"
                   :key="index">
                <div class="left_contents">{{ item.channelTypeName }}</div>
                <div class="right_contents">
                  <div class="right_items" v-for="(items,indexs) in item.staffChannels" :key="indexs">
                    <div class="account_index">{{ indexs + 1 }}</div>
                    <div class="account_box" @click="bindInfo(items)">{{ items.name }}</div>
                    <div class="account_name">{{ items.account }}</div>
                    <div class="account_code">{{ items.code }}</div>
                    <div class="account_putWay">{{ items.putWayName }}</div>
                    <div class="account_des">{{ items.descr }}</div>
                    <div class="contun_box_c disabled_tab">
                      <span class="box_icons"
                            :class="{'active_none':items.status==0}">{{ items.status ? '启用' : '禁用' }}</span>
                    </div>
                    <div class="contun_box_c">
                      <el-button @click="deleteBindAccount(items)" size="mini" type="text" plain>解绑</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
        title="投放账号绑定"
        :visible.sync="releaseAccountBinding"
        :close-on-click-modal="false"
        width="1070px"
        class="public-dialog"
    >
      <div style="cursor: pointer" class="public-dialog-form" v-loading="loading">
        <div style="display: flex">
          <div class="channel_items" style="align-items: center">
            <div class="titles">名称：</div>
            <div>{{ UserInformation.name }}</div>
          </div>
          <div class="channel_items" style="align-items: center">
            <div class="titles">账号：</div>
            <div> {{ UserInformation.account }}（{{ UserInformation.number }}）</div>
          </div>
        </div>
        <div class="channel_items" style="align-items: center">
          <div class="titles">部门/岗位：</div>
          <div>{{ UserInformation.org ? UserInformation.org.name : '' }} /
            {{ UserInformation.post ? UserInformation.post.name : '' }}
          </div>
        </div>
        <div class="channel_items" style="cursor: pointer">
          <div class="titles">渠道账户：</div>
          <div class="table_cou">
            <div class="tab_header_th">
              <div class="names">渠道</div>
              <div class="inde_auto">序号</div>
              <div class="name_box_auto">名称</div>
              <div class="comtemts">账号</div>
              <div class="code_box">标识</div>
              <div class="post_inof">投放方式</div>
              <div class="code_box">说明</div>
              <div class="qutuns">状态</div>
              <div class="qutuns">操作</div>
            </div>
            <div class="tab_body_content">
              <div class="tab_content_td" v-if="item.staffChannels.length" v-for="(item,index) in channelList"
                   :key="index">
                <div class="left_contents">{{ item.channelTypeName }}</div>
                <div class="right_contents">
                  <div class="right_items" v-for="(items,indexs) in item.staffChannels" :key="indexs">
                    <div class="account_index">{{ indexs + 1 }}</div>
                    <div class="account_box" @click="bindInfo(items)">{{ items.name }}</div>
                    <div class="account_name">{{ items.account }}</div>
                    <div class="account_code">{{ items.code }}</div>
                    <div class="account_putWay">{{ items.putWayName }}</div>
                    <div class="account_des">{{ items.descr }}</div>
                    <div class="contun_box_c disabled_tab">
                      <span class="box_icons"
                            :class="{'active_none':items.status==0}">{{ items.status ? '启用' : '禁用' }}</span>
                    </div>
                    <div class="contun_box_c">
                      <el-button v-if="items.bind==0" @click="addBindAccount(items)" size="mini" type="text" plain>添加
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--绑定信息详情-->
    <el-dialog
        title="绑定信息"
        :visible.sync="bindingInfo"
        :close-on-click-modal="false"
        width="580px"
        class="public-dialog"
    >
      <div class="public-dialog-form" v-loading="loading" style="padding-bottom:15px">
        <div class="items">
          <div class="left_name">名称：</div>
          <div class="right_content">{{ accountBindInfo.channelTypeName }}（{{ accountBindInfo.code }}）</div>
        </div>
        <div class="info_tab_tas">
          <div class="items">
            <div class="left_name"> 账号：</div>
            <div class="right_content">{{ accountBindInfo.account }}</div>
          </div>
          <div class="items">
            <div class="left_name">投放方式：</div>
            <div class="right_content">{{ accountBindInfo.putWayName }}</div>
          </div>
        </div>
        <div class="items" v-if="accountBindInfo.orgName">
          <div class="left_name">绑定部门：</div>
          <div class="right_content">{{ accountBindInfo.orgName }}</div>
        </div>
        <div class="items" v-if="accountBindInfo.number">
          <div class="left_name">绑定业务员：</div>
          <div class="right_content">{{ accountBindInfo.name }}（{{ accountBindInfo.number }}）</div>
        </div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";
import {ossUpload} from "@utils/filters/upload";

export default {
  data() {
    var checkAccount = (rule, value, callback) => {
      if (value) {
        if (/[^\w\.\/]/gi.test(value)) {
          callback(new Error("请不要输入中文和空格！"));
        } else {
          callback();
        }
      }
      callback();
    };
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},
      value1: "", //select2
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {
        sex: 1
      }, //弹窗修改数据
      rules: {
        account: [
          {required: true, message: "请填写账号"},
          {max: 10, message: "最多10个字符"},
          {validator: checkAccount, trigger: "blur"},
        ],
        name: [
          {required: true, message: "请填写姓名"},
        ],
        phone: [
          {required: true, message: "请填写手机号码"},
          {min: 11, max: 11, message: "手机号为11个字符", trigger: "change"},
          {
            pattern:
                /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
      }, //表单验证提示
      tableData: [], //二级--管理员列表
      trees: {
        tree: true,
      },
      treeList: [], //left Tree
      defaultProps_one: {
        children: "orgs",
        label: "name",
      }, //最左边显示的组织树--
      orgsProps: {
        children: "orgs",
        label: "name",
      }, //组织的树--弹窗
      positionProps: {
        children: "posts",
        label: "name",
      }, //岗位的树--弹窗
      defaultProps: {
        children: "roles",
        label: "name",
      }, //角色树--弹窗
      permissionData: [], //管理员--菜单树--弹窗
      orgData: [], //组织和岗位
      posData: [], //组织和岗位
      dictDataSelect: "", //弹窗选择的组织
      positionDataSelect: "", //弹窗选择的岗位
      isTreeCheck: true, //左侧树是否激活点击
      activeID: -1,// 激活样式
      channelDialogVisible: false,
      UserInformation: {},
      channelList: [],
      accountnNumberList: [],
      releaseAccountBinding: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
      launchShow: false,
      roleShow: false,
      resetShow: false,
      srcList: [],
      isMoer: true,
      bindingInfo: false,
      accountBindInfo: {}
    };
  },
  created() {
    this.getOrgAndPosi(); //获取组织和岗位的列表
    this.getstaffList();
    this.getPermissionData(); //获取所有菜单权限项目
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.dictDataSelect = ""; //清空选择的组织
        this.positionDataSelect = ""; //清空选择的岗位
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    async bindInfo(e) {
      this.loading = true;
      const {data: resData} = await this.$get(`/channel/account/bind/info?channelAccountId=` + e.channelAccountId);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      this.accountBindInfo = resData.data
      this.bindingInfo = true
    },

    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },

    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.head = this.srcList[0];
    },

    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:admin:reset') {
            this.resetShow = true
          }
          if (item.code == 'system:admin:role') {
            this.roleShow = true
          }
          if (item.code == 'system:admin:launch') {
            this.launchShow = true
          }
          if (item.code == 'system:admin:query') {
            this.searchShow = true
          }
          if (item.code == 'system:admin:add') {
            this.addShow = true
          }
          if (item.code == "system:admin:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:admin:edit") {
            this.editShow = true
          }
          if (item.code == "system:admin:status") {
            this.statusShow = false
          }
        })
      }
    },


    channelViewPermissions(e, index, indexs) {
      let params = {
        channelAccountId: e.channelAccountId,
        staffId: this.UserInformation.staffId
      }
      this.$put(`/staff/channel/dv/status`, params).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    channelOperationAuthority(e, index, indexs) {
      let params = {
        channelAccountId: e.channelAccountId,
        staffId: this.UserInformation.staffId
      }
      this.$put(`/staff/channel/oper/status`, params).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    // 解除绑定
    deleteBindAccount(e) {
      this.$confirm("确认解除当前绑定账号, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete("/staff/channel/bind/status",
            {
              data: {
                channelAccountId: e.channelAccountId,
                orgId: this.UserInformation.org.orgId,
                staffId: this.UserInformation.staffId
              }
            },
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getChannelList(this.UserInformation)
        this.changBindShow(1)
        this.releaseAccountBinding = false
        this.$message.success("解绑成功!");
      })
    },
    // 绑定账号？
    addBindAccount(e) {
      let obj = {
        channelAccountId: e.channelAccountId,
        orgId: this.UserInformation.org.orgId,
        staffId: this.UserInformation.staffId
      }
      this.$confirm("确认绑定当前投放账号, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const {data: resData} = await this.$post(
            "/staff/channel/bind/status",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getChannelList(this.UserInformation)
        this.changBindShow()
        this.$message.success("添加成功!");
      })
    },

    //可绑定列表
    async changBindShow(e) {
      this.loading = true;
      const {data: resData} = await this.$get(`/staff/channel/list?orgId=` + this.UserInformation.org.orgId);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      this.channelList = resData.data
      if (e != 1) {
        this.releaseAccountBinding = true
      }
    },

    async getChannelList(e) {
      this.loading = true;
      this.UserInformation = e
      const {data: resData} = await this.$get(`/staff/channel/bind/list?staffId=` + e.staffId);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      this.accountnNumberList = resData.data
      this.channelDialogVisible = true
    },
    // 获取组织和岗位  赋值左侧组织树
    async getOrgAndPosi() {
      const {data: orgData} = await this.$get(`/org/list?tree=true`);
      const {data: posData} = await this.$get(`/post/list?tree=true`);
      this.orgData = orgData.data;
      this.posData = posData.data;
      // 赋值左侧组织树
      this.treeList = orgData.data;
    },
    //查询管理员
    SearchAdminLsit() {
      this.page.pageNo = 1
      this.getstaffList()
    },
    //管理员列表
    async getstaffList(node) {
      let http = `/staff/list?tree=${!this.trees.tree}&nodeLevel=2`;
      if (node && node.orgId) {
        this.isTreeCheck == true;
        http = `${http}&orgId=${node.orgId}`;
      } else {
        this.isTreeCheck = false;
      }

      this.loading = true;
      const {data: res} = await this.$get(
          http,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      this.tableData = res.data;
      this.page.count = res.page.count;
    },
    //获取管理员的角色组
    async getPermissionData() {
      const {data: resData} = await this.$get("/role/list?tree=true");
      if (resData.result != 200) return;
      this.permissionData = resData.data;
    },

    //switch状态改变 --接口 修改管理员状态
    handleSwitch(index) {
      this.$put(`/staff/info/status/${this.tableData[index].staffId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    operationSwitch(index) {
      this.$put(`/staff/operate/status/${this.tableData[index].staffId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    LaunchSwitch(index) {
      this.$put(`/staff/market/status/${this.tableData[index].staffId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    //点击组织树--选择组织   orgId   选择岗位树：postId
    handleNodeClick: function (node) {
      this.dictDataSelect = node.name;
      this.params.dictDataSelect = node.name;
      this.params.orgId = node.orgId;
      this.$refs.selectReport.blur();
    },
    handleNodeClickPosi: function (node) {
      this.positionDataSelect = node.name;
      this.params.postId = node.postId;
      this.$refs.selectReportPosi.blur();
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;

      if (type == "edit") {
        //编辑
        this.params = {};
      } else if (type == "change") {
        this.params = {};
        this.srcList = []
        this.params = JSON.parse(JSON.stringify(row)); //这里修改了 深拷贝
        if (row.head) {
          this.srcList[0] = JSON.parse(JSON.stringify(row.head))
        }
        if (row.org) {
          //暂定选择一个组织
          this.dictDataSelect = row.org.name;
        }
        if (row.post) {
          //暂定选择一个岗位
          this.positionDataSelect = row.post.name;
        }
      } else if (type == "menu") {
        //菜单
        var that = this;
        that.params = JSON.parse(JSON.stringify(row)); //这里修改了
        //先获取管理员的权限
        that.$get(`/staff/role/ids?staffId=${row.staffId}`).then((res) => {
          if (res.data.data) {
            that.params.permission = res.data.data;
            this.$refs.treeList.setCheckedKeys(that.params.permission);
          } else {
            that.params.permission = [];
            this.$refs.treeList.setCheckedKeys([]);
          }
        });
      } else {
        this.srcList = []
        //添加
        this.params = {
          sex: 1,
        };
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        if (!this.params.orgId) {
          this.params.orgId = this.params.org ? this.params.org.orgId : ''
        }
        if (!this.params.postId) {
          this.params.postId = this.params.post ? this.params.post.postId : ''
        }
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "/staff/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            // this.getstaffListTree(); //重新获取数据
            this.getstaffList();
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            if (this.clickType == "change") {
              //修改管理员
              // passData.staffId = JSON.parse(
              //   JSON.stringify(this.params.staffId)
              // );
              const {data: resData} = await this.$put(
                  "/staff/info",
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              // this.getstaffListTree(); //重新获取数据
              this.getstaffList();

              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            } else {
              //菜单分配
              const permission = this.$refs.treeList.getCheckedKeys();

              if (!permission) return this.$message.error("请选择角色渠道！");

              const {data: resData} = await this.$post(
                  "/staff/role/ids",
                  {
                    roleIds: permission,
                    staffId: this.params.staffId,
                  },
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              this.dialogVisible = false;
              this.$message.success("添加菜单成功!");
            }
          }
        });
      });
    },

    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/staff/info/${row.staffId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getstaffList();
        this.$message.success("删除成功!");
      });
    },
    //重置密码
    async reset(row) {
      this.$confirm('请选泽你需要重置的内容?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '登录密码',
        cancelButtonText: '操作密码',
        type: 'warning'
      }).then(async () => {
        const {data: resData} = await this.$put(
            `/staff/reset/pwd/${row.staffId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getstaffList();
        this.$message.success("已重置登录密码!");
      }).catch(async (action) => {
        if (action === 'cancel') {
          const {data: resData} = await this.$put(
              `/staff/reset/operate/pwd/${row.staffId}`,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.getstaffList();
          this.$message.success("已重置操作密码!");
        }
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getstaffList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getstaffList();
    },
  },
};
</script>
<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: 26px;
  top: 32%;
  transform: translateY(-50%);
}

.role {
  display: flex;
  // gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    padding-right: 15px;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }

  &Right {
    flex: 1;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #ccc;
    padding-left: 15px;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.dialog-tree {
  max-height: 420px;
  overflow-y: auto;
}

.role .el-button--small, .el-button--small.is-round {
  padding: 5px 10px !important;
}

.channel_items {
  display: flex;
  margin-bottom: 15px;

  .titles {
    width: 80px;
    text-align: right;
  }
}

.table_cou {
  height: auto;
  width: calc(100% - 80px);

  .tab_header_th {
    height: 30px;
    border: 1px solid rgba(231, 231, 231, 1);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-left: 1px solid rgba(231, 231, 231, 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .qutuns {
      width: 100px;
    }

    .names {
      width: 80px;
    }

    .name_box_auto {
      width: 220px;
    }

    .code_box {
      width: 100px;
    }

    .post_inof {
      width: 80px;
    }

    .inde_auto {
      width: 50px;
    }

    .comtemts {
      width: 120px;
    }
  }

  .tab_body_content {
    .tab_content_td {
      display: flex;
      border: 1px solid rgba(231, 231, 231, 1);
      border-top: none;
      box-sizing: border-box;
      min-height: 30px;
      border-bottom: none;
    }

    .right_contents {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: calc(100% - 80px);

      .right_items {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 30px;
        border-bottom: 1px solid rgba(231, 231, 231, 1);

        div {
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-left: 1px solid rgba(231, 231, 231, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .account_index {
          width: 50px;
        }
      }

      .account_box {
        width: 200px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left !important;
      }

      .contun_box_c {
        width: 100px;
        border-left: 1px solid rgba(231, 231, 231, 1);

        .box_icons {
          padding: 5px 10px;
          font-size: 12px;
          color: #ffffff;
          background-color: #3a8ee6;
          border-radius: 4px;
        }

        .active_none {
          background-color: rgba(0, 0, 0, 0.1);
          color: #606266;
        }
      }

      .account_name {
        width: 100px;
        padding: 0 10px;
      }

      .account_code {
        width: 100px;
      }

      .account_putWay {
        width: 80px;
      }

      .account_des {
        width: 100px;
      }
    }

    .left_contents {
      width: 80px;
      border-bottom: 1px solid rgba(231, 231, 231, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.items {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .left_name {
    width: 120px;
    text-align: right;

  }
}

.info_tab_tas {
  display: flex;
  align-items: center;
}
</style>